import React from 'react';
import { Card, CardContent, FormField, Input, Translate } from "$common";

const Brief = props => (
  <Card>
    <CardContent extraPadding>
      <FormField name="name" label={Translate.get('title')}>
        <Input />
      </FormField>
      {
        props.defaults.short_description ?
          <FormField name="short_description" label={Translate.get('brief')}>
            <Input rows={4}/>
          </FormField>
        :
          [
            <FormField name="short_description_1" label={Translate.get('description')} key={0}>
              <Input rows={3}/>
            </FormField>,
            <FormField name="short_description_2" label={Translate.get('goals_of_this_research')} key={1}>
              <Input rows={3}/>
            </FormField>,
            <FormField name="short_description_3" label={Translate.get('important_points')} key={2}>
              <Input rows={3}/>
            </FormField>
          ]
      }
    </CardContent>
  </Card>
)

export default Brief;



// WEBPACK FOOTER //
// ./src/components/projects/create/steps/brief.js